export default "__VITE_ASSET__BCf0SZjC__"